import { AbilityBuilder, createMongoAbility } from '@casl/ability';

export const defineAbilitiesFor = (permissions = []) => {
  const { can, rules } = new AbilityBuilder(createMongoAbility);

  permissions.forEach(({ action}) => {
    can(action, "resource");; // Dynamic conditions from backend
  });

  return createMongoAbility(rules);
};
